import $ from "jquery";
export function initDetail() {
  const urlMap = {
    1: "1introduce.html", // 流体物理研究所 (一所)
    2: "2introduce.html", // 总体工程研究所 (四所)
    3: "3introduce.html", // 电子工程研究所 (五所)
    4: "4introduce.html", // 机械制造工艺研究所 (六所)
    5: "5introduce.html", // 激光聚变研究中心 (八所)
    6: "6introduce.html", // 计算机应用研究所 (十二所)
    7: "7introduce.html", // 科技信息中心 (信息中心)
    8: "8introduce.html", //计量测试中心 (计测中心)
  };

  const ele = $("h5.title-text");
  let index = 1;
  ele.map((i) => {
    $(ele[i]).attr("id", index++);
  });

  $("h5.title-text").bind("click", function () {
    let id = $(this).attr("id");
    if (urlMap[id]) {
      window.open(urlMap[id], "_self");
    }
  });
}
